module.exports = __webpack_public_path__ + "img/zero_emissiezones.2c841bda.jpg";